import React from 'react';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import Info from '../../../../../../components/channel-configuration/info';
import { InputSliderDialog } from '../../../../../../components/input-slider-dialog';
import { useBackdropContext } from '../../../../../../context/backdrop';
import { BlindFeatureTypeInternal } from '../../../../../../data-access/gql-types/graphql';
import { useSetBlindSensitivityAOK } from '../../../../api/blind/blind.hooks';
import { useDevicesAndChannelsContext } from '../../../../context/devices-and-channels';
import { useApiErrors } from '../../../../hooks/api-errors/use-api-errors';
import { ChannelCoverType } from '../../../../types';

type BlindSensitivityProps = {
  setTimeoutError: () => void;
};

export const BlindSensitivity: React.FC<BlindSensitivityProps> = ({ setTimeoutError }) => {
  const { t } = useTranslation('channel-settings');
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();
  const { mutate } = useSetBlindSensitivityAOK();
  const { channel } = useDevicesAndChannelsContext();
  const { errors, clearErrors, handleErrors } = useApiErrors();
  const channelData = channel?.data as ChannelCoverType | undefined;

  const supportedFeatures = channelData?.supportedBlindFeatures || [];
  const sensitivityAokSupported = supportedFeatures.includes(BlindFeatureTypeInternal.SensitivityAok);
  const channelSensitivity = channelData?.sensitivityAOK || null;

  const onChangeSensitivity = (value: number | null) => {
    clearErrors();
    if (!channel || !value) return;

    if (channelSensitivity !== value) {
      turnOnBackdrop();

      mutate(
        { channelId: channel.id, deviceId: channel.deviceId, sensitivity: value },
        {
          onSuccess: () => {
            setTimeoutError();
          },
          onError: (error: AxiosError) => {
            turnOffBackdrop();
            handleErrors(error);
          },
        },
      );
    }
  };

  if (!sensitivityAokSupported) return null;

  return (
    <div className="max-width-desktop">
      <hr />
      <Info title={t('sensitivity')} />

      <InputSliderDialog
        value={channelSensitivity}
        handleSaveValue={(val) => onChangeSensitivity(val)}
        min={1}
        max={5}
        step={1}
        dialogTitle={t('sensitivity')}
        unit=""
        errorMessage={errors['Sensitivity']}
      />
    </div>
  );
};
